import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@emotion/react';
import PropTypes from 'prop-types';
import { getContent } from 'pp-react-l10n';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import { Dialog } from '@paypalcorp/pp-react-modal';
import { Alert as Alert$1 } from '@paypalcorp/pp-react-alert';
import { Link } from '@paypalcorp/pp-react-links';
import { LoadingSpinner } from '@paypalcorp/pp-react-loading-spinner';
import { Card } from '@paypalcorp/pp-react-card';
import '../__generated__/styles/alerts.css';

// //https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/onreadystatechange
var getData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var config,
      method,
      req,
      response,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          config = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          method = config.method || 'GET';
          _context.prev = 2;
          req = new XMLHttpRequest();
          req.open(method, url, true);
          req.withCredentials = config.withCredentials || false;
          _context.next = 8;
          return new Promise(function (resolve, reject) {
            req.onreadystatechange = function () {
              if (req.readyState === 4) {
                if (req.status >= 200 && req.status < 300) {
                  var result = JSON.parse(req.response || req.responseText);
                  resolve(result);
                } else {
                  reject("HTTP Error: ".concat(req.status));
                }
              }
            };
            req.addEventListener('error', function (event) {
              reject(event);
            });
            req.send();
          });
        case 8:
          response = _context.sent;
          return _context.abrupt("return", {
            data: response
          });
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 12]]);
  }));
  return function () {
    return _ref.apply(this, arguments);
  };
}();

/**
 *  method to validate is empty.
 * @param value
 * @returns {boolean}
 */
var isEmpty = function (value) {
  return value === null || _typeof(value) === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};

/**
 * Deep clone to remove the reference of the object.
 * @param data
 * @returns {*}
 */
var deepClone = function (data) {
  try {
    return JSON.parse(JSON.stringify(data));
  } catch (e) {
    return data;
  }
};

/**
 * Get corresponding directionality.
 * 1) First get the direction from html element where this component is loaded
 * 2) If no dir attribute value is found on html element then get the directionality from service response configs object.
 * 3) default fallback to ltr
 *
 * @param responseData
 * @returns {string}
 */
var getDirectionality = function (data) {
  try {
    var htmlEl = document.getElementsByTagName('html');
    var __htmlDir = htmlEl[0].dir;
    if (!isEmpty(__htmlDir)) {
      return __htmlDir;
    }
    var config = data && (data.info || data.config);
    if (config && config.directionality) {
      return config.directionality;
    }
    return 'ltr';
  } catch (e) {
    return 'ltr';
  }
};

// ------- Session storage ----------------------

// Save data to sessionStorage
var setDataInSession = function (key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
};

// Get saved data from sessionStorage
var getDataFromSession = function (key) {
  return JSON.parse(sessionStorage.getItem(key));
};

function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultOptions = {
  pgrp: 'main:help:components',
  page: 'main:help:components',
  comp: 'helpComponents'
};
var analyticsObject = function () {
  try {
    return window && window.PAYPAL && window.PAYPAL.analytics;
  } catch (e) {
    return {};
  }
};

// Get FPTI otions
var getFPTIOptions = function (fptiOptions, eventType) {
  var fpti = window && window.fpti ? deepClone(window.fpti) : {};

  // clearing out error props in case they exist
  fpti.erpg = undefined;
  fpti.erfd = undefined;
  fpti.eccd = undefined;

  // Merge client passed fptiOptions with fpti object.
  fpti = _objectSpread$3(_objectSpread$3({}, fpti), fptiOptions);

  // TODO :: This logic needs to be revisited.
  // FPTI options passed through props

  if (isEmpty(fpti.page) || isEmpty(fpti.pgrp)) {
    fpti.page = defaultOptions.page;
    fpti.pgrp = defaultOptions.pgrp;
  }

  // Resetting to empty string for not to set link/pgln,phlk for ac events.
  fpti.link = '';
  fpti.pgln = '';
  fpti.pglk = '';

  // For click events
  if (fptiOptions.link) {
    fpti.link = fptiOptions.link;
    fpti.pgln = "".concat(fpti.page, "|").concat(fptiOptions.link);
    fpti.pglk = "".concat(fpti.pgrp, "|").concat(fptiOptions.link);
  }

  // Add event name to FPTI object
  fpti.event_name = '';
  if (fptiOptions.event_name) {
    fpti.event_name = fptiOptions.event_name;
  }

  // component name priority - fpti options props/analytics window object/default fallback
  if (isEmpty(fpti.comp)) {
    fpti.comp = defaultOptions.comp;
  }
  // Set event Type
  fpti.e = eventType ? eventType : 'ac'; // default activity event

  return fpti;
};

/**
 * @description
 *
 * Logs click metrics
 * @param {Object} fptiOptions
 * @property {String} options.data.page - Page name if not provided derived from the base page
 * @property {String} options.data.pgrp - Page group if not provided derived from the base page
 * e.g. var options = {data: {page:'page_name', pgrp: 'page_group_name'} }
 */
//https://github.paypal.com/pages/Tracking-R/client-side-instrumentation/react.html#/links?_k=flh93g
var recordClickEvent = function (fptiOptions) {
  if (analyticsObject()) {
    var options = getFPTIOptions(fptiOptions, 'cl');
    window.PAYPAL.analytics.Analytics.prototype.recordClick({
      data: options
    });
  }
};

// Error tracking
// https://github.paypal.com/pages/Tracking-R/client-side-instrumentation/#record_error
var recordErrorEvent = function (error) {
  if (window.PAYPAL && window.PAYPAL.trackJSError) {
    window.PAYPAL.trackJSError(error);
  }
};

// Record Activity Events
var recordEvent = function (fptiOptions) {
  if (analyticsObject()) {
    var options = getFPTIOptions(fptiOptions, 'ac');
    window.PAYPAL.analytics.Analytics.prototype.recordEvent(options.event_name, {
      data: options
    });
  }
};

// FPTI Prop Type
var FPTI_OBJECT = {
  page: PropTypes.string.isRequired,
  pgrp: PropTypes.string.isRequired,
  comp: PropTypes.string
};

var sizes = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg'
};
var spinnerTypes = {
  SHIMMER: 'shimmer',
  LOADER: 'loader'
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      error: null,
      errorInfo: null
    };
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(err, errorInfo) {
      this.setState({
        err: err,
        errorInfo: errorInfo
      });
      if (typeof this.props.cbOnError === 'function') {
        // Callback function to track errors.
        this.props.cbOnError(err, errorInfo);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.error) {
        // render any custom fallback UI
        return this.props.children;
      }
      if (this.props.suppressError) {
        return /*#__PURE__*/React.createElement("div", null);
      }
      return /*#__PURE__*/React.createElement("h1", null, 'Something went wrong in loading the widget.');
    }
  }]);
  return ErrorBoundary;
}(React.Component);
ErrorBoundary.propTypes = {
  suppressError: PropTypes.bool.isRequired,
  children: PropTypes.node,
  cbOnError: PropTypes.func.isRequired // callback function on error.
};

function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function HcDialog(props) {
  var dialogState = props.dialogState,
    setDialogState = props.setDialogState,
    parseContent = props.parseContent,
    getHTMLElement = props.getHTMLElement,
    fptiOptions = props.fptiOptions,
    handleRemoveAlert = props.handleRemoveAlert,
    pageName = props.pageName,
    componentName = props.componentName;
  var handleDialogClose = function (e) {
    e.stopPropagation();
    var alertCloseFptiOptions = _objectSpread$2(_objectSpread$2({}, fptiOptions), {}, {
      comp: componentName,
      link: "alert|".concat(dialogState.dialogAlert.messageType, "|alert-dialog|close-button|clicked"),
      page: fptiOptions.page + "-dialog",
      event_name: "hc_alert_closed_in_alert_dialog_".concat(pageName)
    });
    recordClickEvent(alertCloseFptiOptions);
    handleRemoveAlert(dialogState.dialogAlert.docid);
    setDialogState(_objectSpread$2(_objectSpread$2({}, dialogState), {}, {
      dialogIsOpen: false,
      dialogAlert: {}
    }));
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dialog, {
    onClose: function onClose(e) {
      return handleDialogClose(e);
    },
    isOpen: dialogState.dialogIsOpen,
    className: "hc_alert__message--dialog",
    "data-testid": "hc-alert-full-message-dialog",
    style: {
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  }, function renderDialogMessage() {
    if (Object.keys(dialogState.dialogAlert).length !== 0) {
      var innerHTML = getHTMLElement({
        message: dialogState.dialogAlert.message,
        useHTML: true
      });
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          return parseContent(el, dialogState.dialogAlert.messageType, true);
        }
      }, innerHTML);
    }
    return null;
  }()));
}
HcDialog.propTypes = {
  getHTMLElement: PropTypes.func.isRequired,
  handleRemoveAlert: PropTypes.func.isRequired,
  parseContent: PropTypes.func.isRequired,
  dialogState: PropTypes.object.isRequired,
  fptiOptions: PropTypes.shape(FPTI_OBJECT).isRequired,
  setDialogState: PropTypes.func.isRequired,
  pageName: PropTypes.string.isRequired,
  componentName: PropTypes.string.isRequired
};

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var alertTypeMapping = {
  critical: 'error',
  warning: 'warning',
  info: 'info'
};
function Alert(props) {
  var alertData = props.alertData,
    getHTMLElement = props.getHTMLElement,
    handleRemoveAlert = props.handleRemoveAlert,
    parseContent = props.parseContent,
    metaData = props.metaData,
    fptiOptions = props.fptiOptions,
    setDialogState = props.setDialogState,
    pageName = props.pageName,
    componentName = props.componentName;
  var _useState = useState({
      height: window.innerHeight,
      width: window.innerWidth
    }),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setDimensions = _useState2[1];
  var handleResize = function () {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth
    });
  };
  useEffect(function () {
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var handleReadMoreClick = function (e, alert) {
    e.stopPropagation();
    recordClickEvent(_objectSpread$1(_objectSpread$1({}, fptiOptions), {}, {
      comp: componentName,
      link: "alert|".concat(alert.messageType, "|read-more|clicked"),
      event_name: "hc_alert_read_more_clicked_in_".concat(pageName, "_page")
    }));
    setDialogState({
      dialogIsOpen: true,
      dialogAlert: alert
    });
    recordEvent(_objectSpread$1(_objectSpread$1({}, fptiOptions), {}, {
      comp: componentName,
      page: fptiOptions.page + "-dialog",
      event_name: "hc_".concat(alert.messageType, "_alert_dialog_shown_in_").concat(pageName, "_page")
    }));
  };
  var handleOnClickClose = function (e, alert) {
    e.stopPropagation();
    var alertCloseFptiOptions = _objectSpread$1(_objectSpread$1({}, fptiOptions), {}, {
      comp: componentName,
      link: "alert|".concat(alert.messageType, "|close-button|clicked"),
      event_name: "hc_alert_closed_in_".concat(pageName, "_page")
    });
    recordClickEvent(alertCloseFptiOptions);
    handleRemoveAlert(alert.docid);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Alert$1, {
    "data-testid": "hc-alert-".concat(alertData.messageType),
    id: alertData.docid,
    type: alertTypeMapping[alertData.messageType],
    className: "hc_alert",
    closeButton: {
      'aria-label': 'dismiss alert',
      onClick: function onClick(e) {
        return handleOnClickClose(e, alertData);
      }
    }
  }, function renderAlertMessage(alert) {
    var message = alert.message;
    var innerHTML = getHTMLElement({
      message: message,
      useHTML: true
    });
    return message ? /*#__PURE__*/React.createElement("div", {
      className: "hc_alert__message",
      id: "alert-message-".concat(alert.docid),
      ref: function ref(el) {
        return parseContent(el, alert.messageType, false);
      }
    }, innerHTML) : null;
  }(alertData), function renderReadMore(alert) {
    var isInverse = alert.messageType === 'critical' || false;
    var ele = document.getElementById("alert-message-".concat(alert.docid));
    if (ele !== null && ele.scrollHeight > ele.clientHeight) {
      return /*#__PURE__*/React.createElement("span", null, "...", /*#__PURE__*/React.createElement(Link, {
        inverse: isInverse,
        secondary: !isInverse,
        onClick: function onClick(e) {
          return handleReadMoreClick(e, alert);
        }
      }, metaData.readMoreLabel));
    }
    return null;
  }(alertData)));
}
Alert.propTypes = {
  alertData: PropTypes.object.isRequired,
  getHTMLElement: PropTypes.func.isRequired,
  handleRemoveAlert: PropTypes.func.isRequired,
  parseContent: PropTypes.func.isRequired,
  metaData: PropTypes.object.isRequired,
  fptiOptions: PropTypes.shape(FPTI_OBJECT).isRequired,
  setDialogState: PropTypes.func.isRequired,
  pageName: PropTypes.string.isRequired,
  componentName: PropTypes.string.isRequired
};

function Loader(props) {
  var spinnerType = props.spinnerType,
    spinnerSize = props.spinnerSize,
    customLoaderStyle = props.customLoaderStyle;
  return function renderLoader() {
    // Shimmer loader
    var customStyle;
    if (spinnerType === spinnerTypes.SHIMMER) {
      customStyle = customLoaderStyle || {
        height: '12rem',
        width: '100%'
      };
      return /*#__PURE__*/React.createElement("div", {
        style: customStyle
      }, /*#__PURE__*/React.createElement(Card, {
        isLoading: true
      }));
    }

    // Spinning loader

    customStyle = customLoaderStyle || {
      display: 'flex',
      justifyContent: 'center'
    };
    return /*#__PURE__*/React.createElement("div", {
      style: customStyle
    }, /*#__PURE__*/React.createElement(LoadingSpinner, {
      screenReaderText: "loading",
      size: spinnerSize
    }));
  }();
}

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ALERTS_SESSION_KEY = 'hc-alerts';
var getAlertsApiUrl = function (pageName) {
  return "/smarthelp/api/hc-web-alerts?pageName=".concat(pageName);
};
var AlertsContainer = function (props) {
  var fptiOptions = props.fptiOptions,
    suppressError = props.suppressError,
    componentName = props.componentName,
    pageName = props.pageName,
    devData = props.devData,
    devMode = props.devMode,
    spinnerType = props.spinnerType,
    customLoaderStyle = props.customLoaderStyle,
    spinnerSize = props.spinnerSize;

  // State
  var _useState = useState({
      info: {
        directionality: 'ltr'
      },
      alertContent: [],
      listenerForContentLink: false,
      metaData: {}
    }),
    _useState2 = _slicedToArray(_useState, 2),
    alertsState = _useState2[0],
    setAlertsState = _useState2[1];
  var _useState3 = useState({
      dialogIsOpen: false,
      dialogAlert: {},
      listenerForContentLink: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    dialogState = _useState4[0],
    setDialogState = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1]; // For loader purpose

  // Using L10N html to replace dangerouslySetInnerHTML
  var getHTMLElement = function (options) {
    return getContent({
      content: {
        innerMessage: options.message
      },
      path: 'innerMessage',
      useHTML: options.useHTML || false
    });
  };

  // fire fpti ac event for each alert shown on the page
  var handleFPTIsForAlertsShown = function (alerts) {
    if (Array.isArray(alerts) && alerts.length > 0) {
      alerts.forEach(function (alert) {
        var fptiData = _objectSpread(_objectSpread({}, fptiOptions), {}, {
          comp: componentName,
          event_name: "hc_alert_".concat(alert.messageType, "_shown_in_").concat(pageName, "_page")
        });
        recordEvent(fptiData);
      });
    }
  };

  // Filter all the alerts which are closed in that session.
  var filterAlertsBySession = function (alerts) {
    var alertsInSession = getDataFromSession(ALERTS_SESSION_KEY);
    if (alertsInSession) {
      return alerts.filter(function (alert) {
        return !alertsInSession.includes(alert.docid);
      });
    }
    return alerts;
  };

  // Function to set/update final data in state
  var setDataInState = function (responseData) {
    var webAlerts = responseData.webAlerts || [];
    webAlerts = filterAlertsBySession(webAlerts);
    handleFPTIsForAlertsShown(webAlerts);
    return setAlertsState(_objectSpread(_objectSpread({}, alertsState), {}, {
      info: _objectSpread(_objectSpread({}, responseData.info), {}, {
        directionality: getDirectionality(responseData)
      }),
      alertContent: webAlerts,
      metaData: responseData.metaData
    }));
  };

  // Service Call
  var getAlertsContent = function () {
    setIsLoading(true);
    getData(getAlertsApiUrl(pageName)).then(function (response) {
      var data = response.data;
      setDataInState(data);
      setIsLoading(false);
    }).catch(function () {
      var errorFPTIOptions = _objectSpread(_objectSpread({}, fptiOptions), {}, {
        comp: componentName,
        event_name: "hc_alert_service_error"
      });
      recordEvent(errorFPTIOptions);
      setAlertsState(_objectSpread(_objectSpread({}, alertsState), {}, {
        alertContent: []
      }));
      setIsLoading(false);
    });
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(function () {
    var timeoutId;
    if (devMode) {
      timeoutId = setTimeout(function () {
        setDataInState(devData);
        setIsLoading(false);
      }, 2000);
    } else {
      getAlertsContent();
      window.dispatchEvent(new Event('resize'));
    }

    // Return a cleanup function that clears the timeout
    return function () {
      clearTimeout(timeoutId);
    };
  }, []);

  // When any links in the Alert content is clicked
  var handleAlertLinkClick = function (e, link, messageType, isDialogClick) {
    var href = link.getAttribute('href');
    var isDialog = isDialogClick ? '-dialog' : '';

    // Broken link tracking
    if (!href) {
      e.preventDefault();
      recordClickEvent(_objectSpread(_objectSpread({}, fptiOptions), {}, {
        comp: componentName,
        page: fptiOptions.page,
        link: "alert|".concat(messageType, "|content-link|broken-link|clicked"),
        event_name: "hc_alert_content_broken_link_clicked_in_".concat(pageName, "_page")
      }));
    } else {
      var formattedLink = "alert|".concat(messageType, "|content-link|clicked|").concat(href);
      if (isDialog) {
        formattedLink = "alert|".concat(messageType, "|content-link|alert-dialog|clicked|").concat(href);
      }
      recordClickEvent(_objectSpread(_objectSpread({}, fptiOptions), {}, {
        comp: componentName,
        page: (fptiOptions.page + isDialog).trim(),
        link: formattedLink,
        event_name: "hc_alert_content_link_clicked_in_".concat(pageName, "_page")
      }));
    }
  };

  // add event listener for links in alert content
  var addListenerForContentLinks = function (contentLinks, messageType, isDialogClick) {
    Array.from(contentLinks).forEach(function (link) {
      link.addEventListener('click', function (e) {
        return handleAlertLinkClick(e, link, messageType, isDialogClick);
      });
    });
  };

  // check if we should add click listener to avoid duplicate fpti
  var shouldAddListener = function (contentLinks, isDialogContent, messageType) {
    // check for normal alert content
    if (contentLinks.length > 0 && !alertsState.listenerForContentLink && !isDialogContent) {
      setAlertsState(_objectSpread(_objectSpread({}, alertsState), {}, {
        listenerForContentLink: true
      }));
      addListenerForContentLinks(contentLinks, messageType, false);
    }

    // check for dialog content
    if (contentLinks.length > 0 && Object.keys(dialogState.dialogAlert).length !== 0 && isDialogContent && !dialogState.listenerForContentLink) {
      setDialogState(_objectSpread(_objectSpread({}, dialogState), {}, {
        listenerForContentLink: true
      }));
      addListenerForContentLinks(contentLinks, messageType, true);
    }
  };

  // Parsing the links in alert content
  var parseContent = function (content, messageType, isDialogContent) {
    // Adding setTimeout on top as tag element is not picked immediately safari and IE versions
    setTimeout(function () {
      if (!content) {
        return;
      }
      var contentLinks = content.querySelectorAll('a[href]');
      // determine if we need to add click event lisener
      shouldAddListener(contentLinks, isDialogContent, messageType);
    });
  };

  // store docid in the session when user clicks on close button
  var removeAlertToTheUser = function (docid) {
    var closedAlertsInSession = getDataFromSession(ALERTS_SESSION_KEY) || [];
    closedAlertsInSession.push(docid);
    setDataInSession(ALERTS_SESSION_KEY, closedAlertsInSession);
    setAlertsState(_objectSpread(_objectSpread({}, alertsState), {}, {
      alertContent: filterAlertsBySession(alertsState.alertContent)
    }));
  };
  var renderAlerts = function () {
    return alertsState.alertContent.map(function (alert) {
      return /*#__PURE__*/React.createElement(Alert, {
        alertData: alert,
        key: alert.docid,
        getHTMLElement: getHTMLElement,
        handleRemoveAlert: removeAlertToTheUser,
        parseContent: parseContent,
        metaData: alertsState.metaData,
        info: alertsState.info,
        fptiOptions: fptiOptions,
        setDialogState: setDialogState,
        pageName: pageName,
        componentName: componentName
      });
    });
  };
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    suppressError: suppressError,
    cbOnError: function handleErrorBoundaryCatch(error) {
      var finalFPTIOptions = _objectSpread(_objectSpread({}, fptiOptions), {}, {
        comp: componentName,
        event_name: 'hc_alert_error_component_loading'
      });
      recordErrorEvent(error);
      recordEvent(finalFPTIOptions);
    }
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: PAYPAL_THEME
  }, function renderHcAlerts() {
    if (isLoading) {
      return /*#__PURE__*/React.createElement(Loader, {
        spinnerSize: spinnerSize,
        spinnerType: spinnerType,
        customLoaderStyle: customLoaderStyle
      });
    }
    if (Array.isArray(alertsState.alertContent) && alertsState.alertContent.length > 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: "hc_alerts__container",
        "data-testid": "hc-alerts-container",
        dir: alertsState.info.directionality
      }, /*#__PURE__*/React.createElement(HcDialog, {
        dialogState: dialogState,
        setDialogState: setDialogState,
        parseContent: parseContent,
        getHTMLElement: getHTMLElement,
        fptiOptions: fptiOptions,
        handleRemoveAlert: removeAlertToTheUser,
        pageName: pageName,
        componentName: componentName
      }), renderAlerts());
    }
    return null;
  }()));
};
AlertsContainer.propTypes = {
  suppressError: PropTypes.bool,
  componentName: PropTypes.string.isRequired,
  fptiOptions: PropTypes.shape(FPTI_OBJECT).isRequired,
  pageName: PropTypes.string.isRequired,
  spinnerType: PropTypes.oneOf([spinnerTypes.SHIMMER, spinnerTypes.LOADER]),
  spinnerSize: PropTypes.string,
  customLoaderStyle: PropTypes.shape({}),
  // development/github pages purpose only
  devMode: PropTypes.bool,
  devData: PropTypes.shape({})
};
AlertsContainer.defaultProps = {
  suppressError: true,
  devMode: false,
  devData: {},
  spinnerSize: sizes.LARGE,
  spinnerType: spinnerTypes.SHIMMER
};

export { AlertsContainer as HcAlert };
